module.exports = __webpack_public_path__ + "static/media/kikkoman.a58e393f.png";